import { CircularProgress, Box, Text, CloseButton } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { AxiosError } from 'axios';
import { get } from 'lodash-es';
import React from 'react';
import { ErrorIcon, UserAstronautIcon } from 'static/icons';

const BoxStyled = styled(Box)<{ opacity?: number }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  z-index: 100;
  background-color: ${({ opacity = 0.9 }) => `rgba(242, 244, 247, ${opacity})`};
  border-radius: 12px;
`;

export const Loader: React.FC<{
  loading?: boolean;
  error?: AxiosError<unknown> | boolean;
  errorMessage?: string;
  onErrorClose?: () => void;
  opacity?: number;
  astro?: boolean;
}> = ({
  loading,
  error,
  errorMessage,
  onErrorClose,
  opacity,
  astro = false,
}) => (
  <>
    {(loading || error) && (
      <BoxStyled opacity={opacity}>
        {loading ? (
          <CircularProgress isIndeterminate color="highlight" />
        ) : (
          <>
            {onErrorClose && (
              <CloseButton
                onClick={onErrorClose}
                position="absolute"
                right={2}
                top={2}
              />
            )}
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              {astro || get(error, 'response.status') === 404 ? (
                <UserAstronautIcon
                  width="68"
                  height="68"
                  style={{ marginBottom: '16' }}
                />
              ) : (
                <ErrorIcon />
              )}
              <Text textStyle="h4">Ошибка</Text>
              <Text textStyle="body1" color="asphalt.1" textAlign="center">
                {errorMessage ||
                  get(
                    error,
                    'response.data.message',
                    'Проверьте правильность ввода и попробуйте ещё раз',
                  )}
              </Text>
            </Box>
          </>
        )}
      </BoxStyled>
    )}
  </>
);
